import React from "react";
import  Group12 from "../../images/Group12.png";
import  Group13 from "../../images/Group13.png";
import  Group14 from "../../images/Group14.png";
import  Group15 from "../../images/Group15.png";
import  Group16 from "../../images/Group16.png";
import  Group17 from "../../images/Group17.png";
import  Group18 from "../../images/Group18.png";
import  Group19 from "../../images/Group19.png";
import  Group20 from "../../images/Group20.png";

const Services = () => {
  React.useEffect(() => {
    window.scrollTo(0,0)
  }, [])

  return (
    <div className="p-4 md:p-10">
      <div>
        <h1 className="text-center capitalize">Services</h1>
      </div>
      <div className="py-10 grid md:grid-cols-3 place-items-center gap-6">
          <div
            className="bg-gray-lightest transition duration-500 hover:bg-gray-light rounded-lg p-4 w-full space-y-2"
           
          >
              <div>
                 <img src={Group12} alt=""/>
              </div>
              
          </div>
          <div
            className="bg-gray-lightest transition duration-500 hover:bg-gray-light rounded-lg p-4 w-full space-y-2"
           
          >
              <div>
                 <img src={Group13} alt=""/>
              </div>
              
          </div>
          <div
            className="bg-gray-lightest transition duration-500 hover:bg-gray-light rounded-lg p-4 w-full space-y-2"
           
          >
              <div>
                 <img src={Group14} alt=""/>
              </div>
              
          </div>
          <div
            className="bg-gray-lightest transition duration-500 hover:bg-gray-light rounded-lg p-4 w-full space-y-2"
           
          >
              <div>
                 <img src={Group15} alt=""/>
              </div>
              
          </div>
          <div
            className="bg-gray-lightest transition duration-500 hover:bg-gray-light rounded-lg p-4 w-full space-y-2"
           
          >
              <div>
                 <img src={Group16} alt=""/>
              </div>
              
          </div>
          <div
            className="bg-gray-lightest transition duration-500 hover:bg-gray-light rounded-lg p-4 w-full space-y-2"
           
          >
              <div>
                 <img src={Group17} alt=""/>
              </div>
              
          </div>
          <div
            className="bg-gray-lightest transition duration-500 hover:bg-gray-light rounded-lg p-4 w-full space-y-2"
           
          >
              <div>
                 <img src={Group18} alt=""/>
              </div>
              
          </div>
          <div
            className="bg-gray-lightest transition duration-500 hover:bg-gray-light rounded-lg p-4 w-full space-y-2"
           
          >
              <div>
                 <img src={Group19} alt=""/>
              </div>
              
          </div>
          <div className="bg-gray-lightest transition duration-500 hover:bg-gray-light rounded-lg p-4 w-full space-y-2"
           
          >
              <div>
                 <img src={Group20} alt=""/>
              </div>
              
          </div>
        </div>
      </div>
  );
};

export default Services;
